<div class="flex-col flex">
    <div class="mat-subtitle-1 widget-name">{{ label }}</div>
    <div class="widget-container flex-col">
        @for (group of groups; track group; let i = $index) {
            <div class="widget-list-item flex-col">
                <div class="cb-padding-top cb-padding-bottom start-start flex-row flex">
                    <div class="flex-col flex">
                        <span class="mat-body-2">{{ group.key }}</span>
                        @for (child of group.children; track child) {
                            <div class="flex-col">
                                <span class="mat-caption">{{ child.label }}</span>
                            </div>
                        }
                    </div>
                    <!-- TODO: Understand how this works and pass the itemRequiringAction to viewItemUrl instead
          of whatever the group is. -->
                    <button
                        mat-icon-button
                        class="cb-margin-right"
                        (click)="goToItem(viewItemUrl($any(group)), $event)"
                    >
                        <mat-icon>pageview</mat-icon>
                    </button>
                </div>
                @if (i < groups.length - 1) {
                    <hr class="mat-divider" />
                }
            </div>
        }
        @if (!groups || !groups.length) {
            <span class="center-center flex layoutGap-6">
                <mat-icon class="mat-accent">info_circle</mat-icon>
                <div>There are no {{ label || 'Items' }} requiring action</div>
            </span>
        }
    </div>
</div>
